import React from 'react';
import Styles from "../relatedInfo/infoCard.module.scss";
import { Typography } from 'antd';
import CustomIcon from '../icons/CustomIcon';
const { Text } = Typography;
interface Props {
    address: string;
    displayHeader?: string;
    color?: any;
}

const GoogleMaps: React.FC<Props> = ({ address, displayHeader }) => {

    const isNotEmpty = (): boolean => {
        return address.replace(/,/g, '').length > 0;
    }

    const openGoogleMapsWithCurrentLocation = () => {

        if (!isNotEmpty()) {
            return;
        }
        // Check if geolocation is supported by the browser
        if (navigator.geolocation) {
            // Get current location
            navigator.geolocation.getCurrentPosition(function (position) {
                // Construct Google Maps URL with current location as source address
                const currentLocation = `${position.coords.latitude},${position.coords.longitude}`;
                const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLocation}&destination=${encodeURIComponent(address)}`;

                // Open Google Maps URL in a new tab
                window.open(mapsUrl, '_blank');
            }, function (error) {
                // Handle error
                const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
                window.open(mapsUrl, '_blank');
            });
        } else {
            const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
            window.open(mapsUrl, '_blank');
        }
    }

    return (
        <div>
            {/* Row 1 */}
            <div className='d-flex'>
                {/* Component 1 */}
                <div className="pointer" onClick={(ev) => { ev.stopPropagation(); openGoogleMapsWithCurrentLocation() }}>
                    {/* <svg
                        aclassName={"mr-1 font-semibold " + Styles.label}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="18"
                        height="18"
                    >
                        <path
                            fill="currentColor"
                            d="M12 2c-4.418 0-8 3.582-8 8.002 0 3.513 5.8 11.111 7.395 13.229.301.386.7.769 1.205.769.505 0 .905-.383 1.206-.769 1.597-2.118 7.395-9.716 7.395-13.229 0-4.42-3.582-8.002-8-8.002zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
                        />
                    </svg> */}
                    <CustomIcon className={"mr-1 font-semibold " + Styles.label} name="locationPin"></CustomIcon>
                </div>
                {/* Component 2 */}
                <div style={{width:"70%"}}>
                    <Text className={"font-semibold text-xs " + Styles.label}  >{displayHeader}</Text>
                </div>
            </div>
            {/* Row 2 */}
            <div className='mt-2'>
                {/* Component 3 */}
                <Text className={"text-sm " + Styles.value}> {isNotEmpty() ? address : (<Text className='text-xs opacity-5'>Not availabale</Text>)} </Text>
            </div>
        </div>
    );
};

export default GoogleMaps;